function Ghana({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1238)">
        <path d="M0 16C0 17.9571 0.352063 19.8319 0.995188 21.5652L16 22.2609L31.0048 21.5653C31.648 19.8319 32 17.9571 32 16C32 14.0429 31.648 12.1681 31.0048 10.4348L16 9.73914L0.995188 10.4348C0.352063 12.1681 0 14.0429 0 16H0Z" fill="#FFDA44"/>
        <path d="M16 0C9.12061 0 3.25593 4.342 0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0V0Z" fill="#D80027"/>
        <path d="M31.0049 21.5652H0.995239C3.25593 27.6579 9.12061 32 16 32C22.8795 32 28.7442 27.6579 31.0049 21.5652Z" fill="#496E2D"/>
        <path d="M15.9998 10.4348L17.3811 14.6861H21.8516L18.2351 17.3138L19.6164 21.5652L15.9998 18.9377L12.3833 21.5652L13.7648 17.3138L10.1483 14.6861H14.6186L15.9998 10.4348Z" fill="black"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Ghana;
